import {
  Component,
  EventEmitter,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatMenu } from '@angular/material/menu';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Header Menu Mobile
 */
export class HeaderMenuComponent {
  @Output() clickScroll = new EventEmitter<string>();
  @Output() closeMenu = new EventEmitter<any>();
  @ViewChild(MatMenu, { static: true }) menu!: MatMenu;

  /**
   * Scrolls to element
   * @param {string} element
   */
  click(element: string) {
    this.clickScroll.emit(element);
  }
}
